// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import Swiper from 'swiper/js/swiper';

const fragments = {
  SWIPER: '[data-fragment="HorizontalScroll.swiper"]',
  SLIDE: '[data-fragment="HorizontalScroll.slide"]',
  PREV: '[data-fragment="HorizontalScroll.prev"]',
  NEXT: '[data-fragment="HorizontalScroll.next"]',
  NAV: '[data-fragment="HorizontalScroll.nav"]',
  NAV_ITEM: '[data-fragment="HorizontalScroll.navItem"]',
  NAV_BAR: '[data-fragment="HorizontalScroll.navBar"]',
  NAV_PROGRESS: '[data-fragment="HorizontalScroll.navProgress"]',
};

export default class HorizontalScroll extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {
      swiperReady: false,
      activeNavItem: null,
      startOffset: 0,
      endOffset: 0,
    };
    this.swiperReady = this.swiperReady.bind(this);
    this.initSwiper = this.initSwiper.bind(this);
    this.initNav = this.initNav.bind(this);
    this.updateNav = this.updateNav.bind(this);
    this.goTo = this.goTo.bind(this);
    this.setInitSlide = this.setInitSlide.bind(this);
    this.changeUrl = this.changeUrl.bind(this);
  }

  didMount() {
    this.swiperEl = this.element.querySelector(fragments.SWIPER);
    this.navItems = this.element.querySelectorAll(fragments.NAV_ITEM);
    this.slides = this.element.querySelectorAll(fragments.SLIDE);
    this.nav = this.element.querySelector(fragments.NAV);
    this.navBar = this.element.querySelector(fragments.NAV_BAR);
    this.navProgress = this.element.querySelector(fragments.NAV_PROGRESS);
    this.swiper = null;
    this.initSwiper();
    this.on('click', fragments.NAV_ITEM, this.goTo);
    window.addEventListener('resize', this.initSwiper);
  }

  initSwiper = () => {
    if (window.innerWidth > 767) {
      if (!this.swiper) {
        this.swiper = new Swiper(this.swiperEl, {
          speed: 1500,
          mousewheel: true,
          followFinger: false,
          simulateTouch: false,
          navigation: {
            nextEl: fragments.NEXT,
            prevEl: fragments.PREV,
          },
          on: {
            imagesReady: () => setTimeout(() => { this.swiperReady(); }, 0),
          },
        });
        this.swiper.on('slideChange', () => this.updateNav(this.swiper.slides[this.swiper.activeIndex].getAttribute('id')));
        this.swiper.on('slideChange', () => this.changeUrl());
      }
    } else if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  };

  swiperReady = () => {
    this.initNav();
    if (this.element.dataset.initId) {
      this.setInitSlide(this.element.dataset.initId);
    } else {
      this.updateNav(this.navItems[0].dataset.id);
    }
    this.setState({
      swiperReady: true,
    });
  };

  initNav = () => {
    const startOffset = this.navItems[0].offsetWidth / 2;
    const endOffset = this.navItems[this.navItems.length - 1].offsetWidth / 2;
    const navWidth = this.nav.offsetWidth;
    this.setState({
      startOffset: startOffset,
      endOffset: endOffset,
    });
    this.navBar.style.width = `${navWidth - (startOffset + endOffset)}px`;
    this.navBar.style.left = `${startOffset}px`;
  };

  updateNav = (activeId) => {
    if (activeId) {
      for (let i = 0; i < this.navItems.length; i++) {
        classNames(this.navItems[i], { 'horizontal-scroll__nav-item--active': false });
        if (this.navItems[i].dataset.id === activeId) {
          classNames(this.navItems[i], { 'horizontal-scroll__nav-item--active': true });
          const progressWidth = (this.navItems[i].offsetLeft + this.navItems[i].offsetWidth) - this.state.startOffset;
          this.navProgress.style.width = `${progressWidth}px`;
        }
      }
    } else {
      this.updateNav(this.swiper.slides[this.swiper.activeIndex - 1].getAttribute('id'));
    }
  };

  goTo = (e) => {
    e.preventDefault();
    for (let i = 0; i < this.swiper.slides.length; i++) {
      if (this.swiper.slides[i].getAttribute('id') === e.target.dataset.id) {
        this.swiper.slideTo(i);
      }
    }
  };

  setInitSlide = (id) => {
    if (this.swiper) {
      for (let i = 0; i < this.swiper.slides.length; i++) {
        if (this.swiper.slides[i].getAttribute('id') === id) {
          this.swiper.slideTo(i, 0);
        }
      }
    }
  };

  changeUrl = () => {
    const activeIndex = this.swiper.activeIndex;
    let newUrl = this.swiper.slides[activeIndex].dataset.url;
    if (!newUrl) {
      if (activeIndex > 0) {
        newUrl = this.swiper.slides[activeIndex - 1].dataset.url;
      } else {
        newUrl = '/';
      }
    }
    history.replaceState('', '', newUrl);
  };

  willUnMount() {

  }
  update() {
    const { swiperReady } = this.state;
    classNames(this.swiperEl, { 'horizontal-scroll__swiper--ready': swiperReady });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/HorizontalScroll.js